module.exports = "<div class=\"loader\" ng-show=\"$ctrl.show\">\n    <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw loader__spinner\"></i>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./static/js/app/components/loader.component.html
// module id = 605
// module chunks = 1